var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1 -1 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "         M 0, 0 l 3, 3 m 0, -3 l 3, 3 m 0, -3 l 3, 3 m 0, -3 l 3, 3 l 3, -3 m 0, 3 l 3, -3         M 0, 3 l 3, 3 m 12, 0 l 3, -3         M 0, 6 l 3, 3 m 12, 0 l 3, -3         M 0, 12 l 3, -3 m 12, 0 l 3, 3         M 0, 15 l 3, -3 m 12, 0 l 3, 3         M 0, 18 l 3, -3 m 0, 3 l 3, -3 m 0, 3 l 3, -3 m 0, 3 l 3, -3 l 3, 3 m 0, -3 l 3, 3       ",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "         M 6, 3 l 3, 3         M 3, 6 l 3, 3 l -3, 3 l 3, -3         M 6, 15 l 3, -3       ",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "         M 3, 3 l 3, 3 m 3, -3 l 3, 3 l 3, -3         M 3, 15 l 3, -3 m 3, 3 l 3, -3 l 3, 3       ",
    strokeWidth: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "         M 6, 6 l 3, 3 l 3, -3 l 3, 3 l -3, 3 l -3, -3, -3, 3       ",
    strokeWidth: 1.372
  }))));
};

export default __webpack_public_path__ + "static/media/logo.3bc560d5.svg";
export { SvgLogo as ReactComponent };